<template>
  <div>
    <!-- 待出货包裹 抽查项目选择：-->
    <el-dialog :title="$t('message.spotCheckItemSelection')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="980px" center>
      <div class="content">
        <div class="row">
          <div class="search">
            <!--    配送单号  -->
            {{ $t('message.porderNumber') }}：
            <div class="item"> <el-input v-model="porder_sn"></el-input></div>
            <!-- 查询 -->
            <el-button type="primary" @click="spotDetailOptionType">{{ $t('message.inquire') }}</el-button>
          </div>
          <!-- 加入任务 -->
          <el-button type="primary" @click="addToTask">{{ $t('message.addToTask') }}</el-button>
        </div>
        <div class="table">
          <ol>
            <!-- 选择 -->
            <li class="flex05">
              {{ $t("message.choose") }}
            </li>
            <!-- 箱号 -->
            <li class="flex05">{{ $t('message.boxNO') }}</li>
            <!-- 箱规 -->
            <li>{{ $t('message.boxGauge') }}</li>
            <!-- 物流信息 -->
            <li>{{ $t('message.logisticsInformation') }}</li>
          </ol>
          <div class="max-height">
            <ul v-for="(item, index) in tableData" :key="index">
              <!-- 选择 -->
              <li class="flex05">
                <el-checkbox v-model="item.checked"></el-checkbox>
              </li>
              <!-- 箱号 -->
              <li class="flex05">{{ item.number }}</li>
              <!-- 箱规 -->
              <li>
                <div class="template">
                  <p>{{ item.length }}cm * {{ item.width }}cm * {{ item.height }}cm</p>
                  <p style="text-align: center;">{{ item.weight }}kg</p>
                </div>
              </li>
              <!-- 物流信息 -->
              <li>
                <div class="template">
                  物流号：{{ item.express_no }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    taskType: { type: [Number, String] },
  },
  data() {
    return {
      porder_sn: '',
      dialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    // 查询
    spotDetailOptionType() {
      let datas = {
        porder_sn: this.porder_sn,
      }
      this.$api.spotCheckApi.spotDetailOptionType7(datas).then(res => {
        res.data.porder_freight.forEach(item => {
          item.checked = false
          item.porder_freight_id = item.id

        })
        this.tableData = res.data.porder_freight
      })
    },
    //加入任务
    addToTask() {
      let list = []
      this.tableData.forEach(item => {
        if (item.checked) {
          list.push(item)
        }
      })
      if (list == false) return this.$message.error('请选择抽查项目')
      this.$parent.addSpotDetail(list)
      this.dialogVisible = false
    }
  },
};
</script>
<style lang='scss' scoped>
.content {

  min-height: 200px;

  .row {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;

    .search {
      display: flex;
      line-height: 40px;

      .item {
        margin-right: 20px;
      }
    }
  }

  .table {
    border: 1px solid #edeff4;

    .max-height {
      max-height: 600px;
      overflow-y: auto;
    }

    ol {
      display: flex;
      height: 50px;
    }

    ul {
      display: flex;
      padding: 0px 0;

      &:nth-last-child(1) {
        border: 0;
      }


      li {
        padding: 24px 0;

        .item {
          position: relative;

          .num {
            position: absolute;
            top: 0;
            right: 5px;
            color: red;
            font-size: 16px;
          }
        }
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }
  }


}
</style>